<template>
	<div class="info">
		<div class="top">
			<form action="" v-on:submit.prevent="searchs">
				<div>
					<span>医院名称</span><input type="text" v-model="name" placeholder="请输入医院名称">
					<span>搜索词</span><input type="text" v-model="search" placeholder="请输入搜索词">
				</div>
				<div>
					<!-- <span>手机</span><input type="text" v-model="mobile" placeholder="请输入手机号"> -->
					<span>区域</span><input type="text" v-model="area" placeholder="请输入区域">
					<span>座机</span><input type="text" v-model="tel" placeholder="请输入座机号码">
				</div>
				<div>
					
					<!-- <span>坐标</span><input type="text" v-model="coordinate" placeholder="请输入坐标"> -->
					<span>地址</span><input type="text" v-model="address" placeholder="请输入地址">
					<button type="submit">搜索</button>
					<!-- <span>来源</span><input type="text" v-model="form" placeholder="请输入来源"> -->
				</div>
				<div>
					
				</div>
				<div>
					
					
				</div>
			</form>
		</div>
		<div class="list">
			<table border="0" cellspacing="0" cellpadding="0" bordercolor='#979797'>
				<tr>
					<th class="th1">医院名称</th>
					<!-- <th class="th2">手机</th> -->
					<th class="th3">座机</th>
					<th class="th4">地址</th>
					<th class="th5">坐标</th>
					<th class="th6">区域</th>
					<th class="th7">搜索词</th>
					<th class="th8">来源</th>
				</tr>
				<tr :class="[index%2 == 0?'td_1':'td_2']" v-for="(item,index) in list">
					<td>{{item.name}}</td>
					<!-- <td>{{item.mobile}}</td> -->
					<td>{{item.tel}}</td>
					<td>{{item.address}}</td>
					<td>{{item.coordinate}}</td>
					<td>{{item.area}}</td>
					<td>{{item.search}}</td>
					<td class="bor_no">{{item.from}}</td>
				</tr>
			</table>

		</div>
		<div>
			<div class="fen">
				<ul v-if="hidden">
					<li class="shang" @click="shang">上一页</li>
					<li :class="{bg:ind == index}" v-for="(item,index) in num" @click="click_id(item)">{{item}}</li>
					<li class="xia" @click="xia">下一页</li>
					<!-- <li class="xiaFive" v-if="show">下5页</li> -->
				</ul>
			</div>
		</div>
	</div>

</template>

<script>
	// 引入axios
	import axios from 'axios';
	// 引入端口配置文件
	import API_LIST from '@/list.config.js';
	import {
		ElMessageBox,
		ElMessage
	} from 'element-plus'
	import qs from 'qs'
	export default {

		name: "Zi",
		props: {

		},
		data() {
			return {
				page: 1,
				hidden: true,
				num: [],
				counts: Number, // 总页数
				list: [],
				ind: 0,
				name: '',
				mobile: '',
				tel: '',
				address: '',
				from: '',
				search: '',
				area: '',
				coordinate: '',

			}

		},
		watch: {

		},
		computed: {

		},

		created() {
			const that = this;

			axios.post(API_LIST.hospitalList, {
					page: this.page,
					name: '',
					mobile: '',
					tel: '',
					address: '',
					from: '',
					search: '',
					area: '',
					coordinate: '',
				}, {
					headers: {
						// 'Content-Type': 'application/x-www-form-urlencoded'
						'Content-Type': 'application/json'
					} //加上这个x
				})
				.then(_d => {
					console.log(_d.data)
					if (_d.data.status == 200) {
						// console.log(_d)
						that.list = _d.data.list.list;

						that.counts = _d.data.list.page;
						if (_d.data.list.page == 0) {
							that.hidden = false;
							return false
						}
						if (that.num.length + 5 < that.counts) {
							that.num = this.generateArray(1, 5)
							that.show = true
						} else {
							that.num = that.counts
							that.show = false
						}
					} else if (_d.data.status == 409) {

					}


				})
				.catch(function(error) {
					console.log(error);
				});
		},
		mounted() {

		},


		methods: {
			// 上一页
			shang() {
				const that = this;
				if (this.page == 1) {
					ElMessage({
						message: '已经是第一页了',
						type: 'warning',
					})
				} else {
					this.ind--;
					this.page--;
					if (this.page < this.num[0]) {
						that.num = this.generateArray(this.num[0] - 5, this.num[0] - 1)
						this.ind = 4;
					}
					axios.post(API_LIST.hospitalList, {
							page: this.page,
							name: this.name,
							mobile: this.mobile,
							tel: this.tel,
							address: this.address,
							from: this.from,
							search: this.search,
							area: this.area,
							coordinate: this.coordinate,
						}, {
							headers: {
								// 'Content-Type': 'application/x-www-form-urlencoded'
								'Content-Type': 'application/json'
							} //加上这个x
						})
						.then(_d => {
							console.log(_d.data)
							if (_d.data.status == 200) {
								// console.log(_d)
								that.list = _d.data.list.list;

								that.counts = _d.data.list.page;
								if (_d.data.list.page == 0) {
									that.hidden = false;
									return false
								}
								if (that.num.length + 5 < that.counts) {
									that.num = this.generateArray(1, 5)
									that.show = true
								} else {
									that.num = that.counts
									that.show = false
								}
							} else if (_d.data.status == 409) {

							}


						})
						.catch(function(error) {
							console.log(error);
						});
				}
			},
			// 下一页
			xia() {
				const that = this;
				if (that.page == that.counts) {
					ElMessage({
						message: '已经是最后一页了',
						type: 'warning',
					})
				} else {
					this.ind++;
					this.page++;
					if (this.page > this.num[4]) {
						that.num = this.generateArray(this.num[4] + 1, this.num[4] + 5)
						this.ind = 0;
					}
					axios.post(API_LIST.hospitalList, {
							page: this.page,
							name: this.name,
							mobile: this.mobile,
							tel: this.tel,
							address: this.address,
							from: this.from,
							search: this.search,
							area: this.area,
							coordinate: this.coordinate,
						}, {
							headers: {
								// 'Content-Type': 'application/x-www-form-urlencoded'
								'Content-Type': 'application/json'
							} //加上这个x
						})
						.then(_d => {
							console.log(_d.data)
							if (_d.data.status == 200) {
								// console.log(_d)
								that.list = _d.data.list.list;

								that.counts = _d.data.list.page;


							} else if (_d.data.status == 409) {

							}


						})
						.catch(function(error) {
							console.log(error);
						});
				}

			},
			// 点击选择
			click_id(item){
				const that = this;
				this.ind = item-1;
				this.page = item;
				
				axios.post(API_LIST.hospitalList, {
						page: this.page,
						name: this.name,
						mobile: this.mobile,
						tel: this.tel,
						address: this.address,
						from: this.from,
						search: this.search,
						area: this.area,
						coordinate: this.coordinate,
					}, {
						headers: {
							// 'Content-Type': 'application/x-www-form-urlencoded'
							'Content-Type': 'application/json'
						} //加上这个x
					})
					.then(_d => {
						console.log(_d.data)
						if (_d.data.status == 200) {
							// console.log(_d)
							that.list = _d.data.list.list;
							that.counts = _d.data.list.page;
							
						} else if (_d.data.status == 409) {
							
						}
							
							
					})
					.catch(function(error) {
						console.log(error);
					});
			},
			// 搜索
			searchs() {
				const that = this;
				this.ind = 0;
				this.page = 1;
				

				axios.post(API_LIST.hospitalList, {
						page: this.page,
						name: this.name,
						mobile: this.mobile,
						tel: this.tel,
						address: this.address,
						from: this.from,
						search: this.search,
						area: this.area,
						coordinate: this.coordinate,
					}, {
						headers: {
							// 'Content-Type': 'application/x-www-form-urlencoded'
							'Content-Type': 'application/json'
						} //加上这个x
					})
					.then(_d => {
						console.log(_d.data)
						if (_d.data.status == 200) {
							// console.log(_d)
							that.list = _d.data.list.list;

							that.counts = _d.data.list.page;
							if (_d.data.list.page == 0) {
								that.hidden = false;
								return false
							}
							if (5 < that.counts) {
								that.num = this.generateArray(1, 5)
								that.show = true
							} else {
								that.num = that.counts
								that.show = false
							}

						} else if (_d.data.status == 409) {

						}


					})
					.catch(function(error) {
						console.log(error);
					});

			},
			generateArray(start, end) {
				return Array.from(new Array(end + 1).keys()).slice(start)
			}
		},

	};
</script>

<style scoped="scoped" lang="scss">
	.info {
		width: 850px;
		margin: 0 0 0 80px;

		.top {
			display: flex;
			background-color: #F7F9FD;

			form {
				display: flex;
				flex-direction: column;
				box-sizing: border-box;
				padding: 20px 30px;

				div {
					display: flex;
					flex-direction: row;
					/* justify-content: space-around; */
					margin: 0 0 20px 0;
					align-items: center;
					width: 700px;

					span {
						width: 64px;
						text-align: center;

					}

					input {
						width: 161px;
						height: 24px;
						background: #EEEEEE;
						border: 1px solid #DADADA;
						margin: 0 90px 0 0;
						box-sizing: border-box;
						padding: 0 0 0 5px;
					}

					button {
						width: 161px;
						height: 24px;
						background: #39A49B;
						color: #fff;
						margin: 0 0 0 60px;
					}
				}
			}
		}

		table {
			width: 100%;
			margin: 20px 0 0 0;
			// border-right: 1px solid #979797;
			// border-bottom: 1px solid #979797;

			th,
			td {
				text-align: center;
				font-size: 14px;
				height: 53px;
				// border-top: 1px solid #979797;
				border-right: 1px solid #ddd;
			}
			.td_1{
				background: #fff !important;
			}
			.td_2{
				background: #eee !important;
			}
			
			.th1 {
				width: 120px;
				background: #39A49B;
			}

			.th2 {
				width: 110px;
				background: #39A49B;
			}

			.th3 {
				width: 110px;
				background: #39A49B;
			}

			.th4 {
				width: 180px;
				background: #39A49B;
			}

			.th5 {
				width: 100px;
				background: #39A49B;
			}

			.th6 {
				width: 60px;
				background: #39A49B;
			}

			.th7 {
				width: 60px;
				background: #39A49B;
			}
			.th8{
				background: #39A49B;
			}
		}
		.bor_no{
			border:none !important;
		}
		.fen {
			display: flex;
			flex-direction: column;
			margin: 50px auto 0;
			width: 500px;

			// width: 300px;
			ul {

				display: flex;
				flex-direction: row;

				li {
					background-color: #add5d4;
					margin-left: 5px;
					color: #333;
					width: 36px;
					height: 36px;
					line-height: 36px;
					text-align: center;

					// padding: 10px;

				}

				.bg {
					background-color: #39A49B !important;
				}

				li:hover {
					background-color: #39A49B !important;
					cursor: pointer;
				}

				.shang,
				.xia,
				.xiaFive {
					width: 87px;
					height: 37px;
				}

			}
		}

	}
</style>
